export const placeConstants = {
  SET_HOVER: 'SET_HOVER',
  REMOVE_HOVER: 'REMOVE_HOVER',
};
